import { HttpService } from "../HttpService";

/**
 * Get frontend metadata.
 * @returns {Promise<Object>}
 */
export async function getFrontendMetadata() {
  const response = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/public/frontend-metadata/federfarma`);
  return response.data?.metadata;
}
